import { Navigate, Outlet, useLocation } from "react-router";
import { selectIsAuthenticated, useAppSelector } from "../../store";
import { ActivityTracker } from "../ActivityTracker";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";

/**
 * Renders the main app chrome only when the user has signed in.
 */
export const ProtectedLayout = () => {
  const location = useLocation();
  const isAuthed = useAppSelector(selectIsAuthenticated);

  if (!isAuthed) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return (
    <div className="h-screen overflow-hidden bg-white dark:bg-gray-950">
      <ActivityTracker />
      <Sidebar />
      <div className="app-main-with-sidebar flex h-screen min-w-0 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto bg-gray-50 dark:bg-gray-950 min-h-0">
          <div className="flex min-h-[calc(100dvh-var(--app-chrome-header-height))] flex-col">
            <div className="flex-1 w-full">
              <Outlet key={location.pathname} />
            </div>
            <Footer />
          </div>
        </main>
      </div>
    </div>
  );
};
